"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthState = exports.AuthContext = exports.RoleScopeType = void 0;
var react_1 = __importDefault(require("react"));
var RoleScopeType;
(function (RoleScopeType) {
    RoleScopeType["Organization"] = "organization";
    RoleScopeType["Program"] = "program";
    RoleScopeType["Division"] = "ts_division";
})(RoleScopeType = exports.RoleScopeType || (exports.RoleScopeType = {}));
exports.AuthContext = react_1.default.createContext({
    user: null,
    token: '',
    updateToken: function (newtoken) { },
});
exports.AuthContext.displayName = 'Auth Context';
var useAuthState = function () {
    var _a = react_1.default.useState(''), loginToken = _a[0], setLoginToken = _a[1];
    return [loginToken, setLoginToken];
};
exports.useAuthState = useAuthState;
